import { getAppConfigValue } from '@elliemae/pui-app-sdk';

export const LEGACY_DEBUG_PATH = '/pricing/debug.aspx';

// Tech Ops reaches this flow from the legacy ICE PPE debug page, which
// Response.Redirect's into partner-ui in the same tab. Common.closeApplication()
// falls through to window.close(), which browsers ignore for a tab the script
// did not open, so exiting has to navigate back to debug.aspx explicitly.
// The lane's legacy host comes from getLegacyEPPSWebsite in the app config -
// each environment has its own, per EPPSE 230710724.
export const exitToLegacyDebug = () => {
  const legacyWebsite = getAppConfigValue<string>(
    'serviceEndpoints.legacyEPPSWebsite',
  );
  window.location.assign(`${legacyWebsite}${LEGACY_DEBUG_PATH}`);
};
